import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';

class WutonghuiContent extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    render() {
        const { content } = this.props;

        return (
            <ul className={styles.list}>
                {content.map(item => (
                    <li key={item.url}>
                        <a href={item.url} target="_blank">
                            <img src={item.img} alt={item.title} width="140" height="80" border="0" />
                        </a>
                        <p>
                            <a href={item.url} target="_blank">
                                {item.title}
                            </a>
                        </p>
                    </li>
                ))}
            </ul>
        );
    }
}

export default errorBoundary(WutonghuiContent);
